// creates a date object that ends at the end of the current day
export const EndOfDayDate = () => {
    const expire = new Date();

    expire.setDate(expire.getDate() + 1);
    expire.setHours(0);
    expire.setMinutes(0);
    expire.setSeconds(0);

    return expire;
};

// Get Renewal Date based off current date for monthly or yearly term
export const GetRenewalDate = (term) => {
    const expire = new Date();

    if (term === 'month') {
        expire.setDate(expire.getDate() + 30);
        const month = expire.toLocaleString('default', { month: 'long' });
        const day = String(expire.getDate()).padStart(2, '0');
        const year = expire.getFullYear();
        return `${month} ${day}, ${year}`;
    }
    expire.setDate(expire.getDate() + 365);
    const month = expire.toLocaleString('default', { month: 'long' });
    const day = String(expire.getDate()).padStart(2, '0');
    const year = expire.getFullYear();
    return `${month} ${day}, ${year}`;
};
